import { render, staticRenderFns } from "./OSpeedSelect.vue?vue&type=template&id=90ce6038&scoped=true&"
import script from "./OSpeedSelect.vue?vue&type=script&lang=js&"
export * from "./OSpeedSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ce6038",
  null
  
)

export default component.exports